export default function IdleRefreshOverlay() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white p-6">
      <div className="flex flex-col items-center gap-8 text-center">
        <p className="text-lg font-semibold text-zinc-900">Paused after inactivity.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="min-w-64 bg-zinc-900 px-12 py-8 text-3xl font-black text-white hover:bg-zinc-700 focus:outline-none focus:ring-4 focus:ring-zinc-400"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
